// A preview scope isolates concurrent apps on the editor origin. Production defaults stay unchanged.
const scope = process.env.REACT_APP_SESSION_SCOPE || "";
export const TOKEN_KEY = scope ? `wp_token_${scope}` : "wp_token";
export const readToken = () => localStorage.getItem(TOKEN_KEY);
export const saveToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
